import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start at 13 minutes and 11 seconds
  const [timeLeft, setTimeLeft] = useState(13 * 60 + 11);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="sticky top-0 z-50 bg-red-600 text-white py-1 px-3 shadow-sm text-center" role="banner" aria-label="Oferta por tiempo limitado" data-id="element-1">
      <p className="text-xs md:text-sm font-bold flex items-center justify-center gap-1.5 flex-wrap" data-id="element-2">
        <span aria-hidden="true" data-id="element-3">⏳</span>
        <span data-id="element-4"> OFERTA EXPIRA EN:</span>
        <span className="bg-white text-red-600 px-1.5 py-0.5 rounded font-mono text-xs md:text-sm" role="timer" aria-live="polite" aria-label={`${minutes} minutos y ${seconds} segundos restantes`} data-id="element-5">
          {minutes.toString().padStart(2, '0')}:
          {seconds.toString().padStart(2, '0')}
        </span>
        <span data-id="element-6">
          | <span aria-hidden="true" data-id="element-7">🔥</span> CUPOS LIMITADOS
        </span>
      </p>
    </div>;
}